export enum NvRapporteringStatus {
  NotApplicable = "NotApplicable",
  NotReported = "NotReported",
  WaitingForReport = "WaitingForReport",
  Completed = "Completed",
  Ignored = "Ignored",
  AutomaticReportFailed = "AutomaticReportFailed",
  HasReportedPreliminaryWeight = "HasReportedPreliminaryWeight",
}
